module.exports = __webpack_public_path__ + "static/media/AU 2018 Research Roster.2b89cd23.xlsx";